import { render, staticRenderFns } from "./DCList.vue?vue&type=template&id=17b2d546&scoped=true"
import script from "./DCList.vue?vue&type=script&lang=js"
export * from "./DCList.vue?vue&type=script&lang=js"
import style0 from "./DCList.vue?vue&type=style&index=0&id=17b2d546&scoped=true&lang=scss"
import style1 from "./DCList.vue?vue&type=style&index=1&id=17b2d546&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2d546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b2d546')) {
      api.createRecord('17b2d546', component.options)
    } else {
      api.reload('17b2d546', component.options)
    }
    module.hot.accept("./DCList.vue?vue&type=template&id=17b2d546&scoped=true", function () {
      api.rerender('17b2d546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/DC/DCList.vue"
export default component.exports